import { assetUrl } from "./assetUrl";

// A character's voice player (layer.Audio) is a real <audio> object only in the page that made it.
// Copies of the layers (Undo / Redo, copy and paste, saving and loading, the preview's copy of the
// slides) turn it into a plain {} — and calling .pause() on that stopped the timeline's playback
// loop, so the mouth kept talking after the voice ended. This puts a real player back.

function isPlayer(a) {
  return typeof HTMLMediaElement !== "undefined" && a instanceof HTMLMediaElement;
}

/** Repairs the voice players of the given layers in place. */
export function repairVoiceAudio(layers, apiBaseURL) {
  if (!Array.isArray(layers)) return;
  for (const l of layers) {
    if (!l || l.Audio === undefined || l.Audio === null || isPlayer(l.Audio)) continue;
    l.Audio = l.TTSPath ? new Audio(assetUrl(apiBaseURL, l.TTSPath)) : undefined;
  }
}
